import { render } from "./ChartAndSentiment.vue?vue&type=template&id=dd874748&scoped=true"
import script from "./ChartAndSentiment.vue?vue&type=script&lang=js"
export * from "./ChartAndSentiment.vue?vue&type=script&lang=js"

import "./ChartAndSentiment.vue?vue&type=style&index=0&id=dd874748&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd874748"]])

export default __exports__